import React from 'react';
import { Grid } from '@mui/material';

import WrappedSpinner from '../../common/wrapped-spinner';

function VehicleStats({ vehicleRides, isLoading }) {
  const rides = vehicleRides || [];
  const totalTripCount = rides.length;

  return (
    <WrappedSpinner isLoading={isLoading}>
      <Grid item xs={3}>
        Lifetime Trips:&nbsp;
        {totalTripCount}
      </Grid>
      <Grid item xs={12}>&nbsp;</Grid>
    </WrappedSpinner>
  );
}

export default VehicleStats;
